module.exports = __webpack_public_path__ + "static/media/31JFA3.9bdf7a74.jpg";